export const ONBOARDING_KEY = 'conveyrx.onboarding.v1';
/**
 * Bumped when the terminology rename renamed the milestone ids themselves (`place-source` ->
 * `place-observable`, and the rest of the setup arc with it). A stored id that no longer matches
 * any milestone would silently un-dismiss that step, so the whole set is discarded instead.
 */
const ONBOARDING_VERSION = 2;

interface OnboardingPayload {
  version: number;
  seenIds: string[];
}

export function loadSeenIds(): Set<string> {
  try {
    const raw = localStorage.getItem(ONBOARDING_KEY);
    if (!raw) return new Set();
    const payload = JSON.parse(raw) as OnboardingPayload;
    return payload.version === ONBOARDING_VERSION ? new Set(payload.seenIds) : new Set();
  } catch {
    return new Set();
  }
}

export function saveSeenIds(seen: ReadonlySet<string>): void {
  try {
    const payload: OnboardingPayload = { version: ONBOARDING_VERSION, seenIds: [...seen] };
    localStorage.setItem(ONBOARDING_KEY, JSON.stringify(payload));
  } catch {
    /* quota exceeded or storage disabled; onboarding progress just won't persist this session */
  }
}

export function clearSeenIds(): void {
  try {
    localStorage.removeItem(ONBOARDING_KEY);
  } catch {
    /* storage disabled; nothing to clear */
  }
}
